import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import { NAVIGATION_UI_STORAGE_KEY } from '@atlassian/jira-router-resources-navigation-ui-state/src/constants.tsx';
import type {
	LeftSidebarState,
	PreviewPanelState,
	RightSidebarState,
} from '../../../../../common/types.tsx';

export type RemoteLayoutState = {
	leftSidebar: Pick<LeftSidebarState, 'isCollapsed' | 'width'>;
	rightSidebar: RightSidebarState;
	previewPanel?: PreviewPanelState;
};

export async function setRemoteLayoutState({
	accountId,
	state,
}: {
	accountId: string;
	state: RemoteLayoutState;
}) {
	try {
		await setUserProperties(accountId, NAVIGATION_UI_STORAGE_KEY, JSON.stringify(state));
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		fireErrorAnalytics({
			error: e,
			meta: {
				id: 'updateServerLayoutState',
				packageName: 'jiraLayoutController',
				teamName: 'jfp-team',
			},
		});
	}
}
